module.exports = __webpack_public_path__ + "static/media/canceled.981ed125.png";